import Link from "@components/core/Link";
import ProductImage from "@components/core/ProductImage";
import catalogContexts from "@utils/constants/catalogContexts";

const ProductImageLink = ({ algolia, product, onClick, context, ...other }) => {
  const buildUrlPattern = () => {
    let productPathName = "/products/[slug]";

    productPathName += `?algoliaQueryId=${algolia?.query_id}&algoliaIndexName=${algolia?.index_name}`;
    if (context === catalogContexts.sales) productPathName += `&context=${catalogContexts.sales}`;

    return productPathName;
  };

  return (
    <Link
      href={buildUrlPattern()}
      as={buildUrlPattern().replace("[slug]", product.slug)}
      passHref
      onClick={onClick}
      data-testid="product-image-link"
      className="d-block w-100 h-100 position-relative"
      {...other}
    >
      <ProductImage
        src={product.main_picture_url}
        alt={product.name || ""}
        sizes="(max-width: 768px) 450px,
        (max-width: 1200px) 600px,
        450px"
      />
    </Link>
  );
};

export default ProductImageLink;
